import { z } from "zod";

import { ManifestIdSchema, VersionStringSchema } from "../manifest";

/**
 * Wire contract version for deployed-flow introspection snapshots.
 *
 * Increment this value when changing the response shape incompatibly.
 */
export const DEPLOYED_FLOW_INTROSPECTION_SCHEMA_VERSION = 1;

const IntrospectionModuleRefSchema = z
  .object({
    moduleId: ManifestIdSchema,
    minVersion: VersionStringSchema,
  })
  .strict();

const IntrospectionViewRefSchema = z
  .object({
    viewId: ManifestIdSchema,
    minVersion: VersionStringSchema,
  })
  .strict();

const IntrospectionBranchSchema = z
  .object({
    branchId: ManifestIdSchema,
    version: VersionStringSchema,
    views: z.array(IntrospectionViewRefSchema),
  })
  .strict();

const IntrospectionFlowSchema = z
  .object({
    flowId: z.string().min(1),
    layout: IntrospectionModuleRefSchema,
    errorView: IntrospectionModuleRefSchema,
    branches: z.array(IntrospectionBranchSchema),
  })
  .strict();

/**
 * Minimal, unauthenticated snapshot of the flows embedded in a deployment.
 *
 * Deliberately excludes module props, flow metadata, host mappings, and all
 * carrier/customer data.
 */
export const DeployedFlowIntrospectionSchema = z
  .object({
    schemaVersion: z.literal(DEPLOYED_FLOW_INTROSPECTION_SCHEMA_VERSION),
    revision: z.string().min(1).nullable(),
    flows: z.array(IntrospectionFlowSchema),
  })
  .strict();
